// https://github.com/vercel/next.js/pull/15772#discussion_r463984612
// eslint-disable-next-line import/no-extraneous-dependencies
import 'core-js/features/object/from-entries';
